import { SessionLoader } from './SessionLoader';
import { Session } from './Session';
import { useAppSelector } from '../../app/hooks';
import { selectSessionState } from '../../app/slices/session.slice';
import { useCreateSession } from '../../hooks/useCreateSession';
import { FC } from 'react';

export const SessionRoot: FC = () => {
	useCreateSession();

	const state = useAppSelector(selectSessionState);

	switch (state) {
		case 'IDLE':
		case 'CREATING':
		case 'CREATED':
		case 'STARTING':
			return <SessionLoader />;
		case 'STARTED':
			return <Session />;
	}
};

export default SessionRoot;
